import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "./api";

export function useFetch(url, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    if (!url) return;
    try { setError(""); const r = await api.get(url); setData(r.data); }
    catch (e) { setError(errMsg(e)); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  useEffect(() => { load(); }, [load]);
  return { data, error, reload: load, setData };
}
